/**
 * Default template tags applied on the scaffolder list page.
 *
 * @remarks
 * This constant is the single source of truth for the default tag filter.
 * To add or remove a default tag, update this array only.
 */
export const DEFAULT_FILTER_TAGS: readonly string[] = ['certified', 'ai-platform'];
